import Api from "./api";

export class CaptchaApi {
    static URL = "ms-sp-consulta-captchas-pga/soporte-ti/v1";

    static captcha = (token: string, codApplication: string) =>
        Api.post(`${CaptchaApi.URL}/support/captcha`, {
            entity: {
                response: token,
                codApplication,
            },
        });
}
